import { useState, useEffect, useCallback } from 'react';

export const useGoogleMaps = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [loadError, setLoadError] = useState(null);
  const [apiKey, setApiKey] = useState(null);

  useEffect(() => {
    const key = process.env.REACT_APP_API_PLACE;
    if (!key) {
      setLoadError("Clé API Google Maps manquante. Vérifiez votre fichier .env");
      return;
    }
    setApiKey(key);
  }, []);

  const handleLoad = useCallback(() => {
    setIsLoaded(true);
    setLoadError(null);
    console.log('Google Maps API chargée avec succès');
  }, []);

  const handleError = useCallback((error) => {
    setIsLoaded(false);
    setLoadError(error);
    console.error('Erreur Google Maps API:', error);
  }, []);

  const isReady = isLoaded && !loadError && apiKey;

  return {
    isLoaded,
    loadError,
    apiKey,
    isReady,
    handleLoad,
    handleError
  };
};

export default useGoogleMaps; 